<!-- 合作页面跳转点击发布跳转至该页面  加强合作页面-->
<template>
  <div class="addCooperation">
    <div class="table">
      <el-form :model="cooperation" :rules="cooperationRules" ref="cooperationForm" class="demo-ruleForm">
        <div class="title clearfix">
          <div class="icon"></div>
          <div class="titleName">公司/学校名称</div>
        </div>
        <el-form-item prop="companyName">
          <el-input v-model="cooperation.companyName" placeholder="请输入公司/学校名称"></el-input>
        </el-form-item>
        <div class="title clearfix">
          <div class="icon"></div>
          <div class="titleName">标题</div>
        </div>
        <el-form-item prop="title">
          <el-input v-model="cooperation.title" placeholder="请输入标题"></el-input>
        </el-form-item>
        <div class="title clearfix">
          <div class="icon"></div>
          <div class="titleName">联系人</div>
        </div>
        <el-form-item prop="name">
          <el-input v-model="cooperation.name" placeholder="请输入联系人"></el-input>
        </el-form-item>
        <div class="title clearfix">
          <div class="icon"></div>
          <div class="titleName">联系方式</div>
        </div>
        <el-form-item prop="phone">
          <el-input v-model="cooperation.phone" placeholder="请输入联系方式" maxlength="11"></el-input>
        </el-form-item>
        <div class="title clearfix">
          <div class="icon"></div>
          <div class="titleName">合作需求说明</div>
        </div>
        <el-form-item prop="content">
          <el-input type="textarea" placeholder="请填写合作需求" v-model="cooperation.content" maxlength="200" show-word-limit
            :autosize="{ minRows: 6, maxRows: 6 }">
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="submit">
      <button class="submitBtn" @click="submit">提 交</button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      cooperation: {
        companyName: "",
        title: "",
        name: "",
        phone: "",
        content: "",
      },
      cooperationRules: {
        companyName: [
          { required: true, message: "请输入公司/学校名称", trigger: "blur" },
          {
            min: 1,
            max: 20,
            message: "长度在 1 到 20 个字符",
            trigger: "blur",
          },
        ],
        title: [
          { required: true, message: "请输入标题", trigger: "blur" },
          {
            min: 1,
            max: 20,
            message: "长度在 1 到 20 个字符",
            trigger: "blur",
          },
        ],
        name: [
          { required: true, message: "请输入联系人", trigger: "blur" },
          {
            min: 1,
            max: 20,
            message: "长度在 1 到 10 个字符",
            trigger: "blur",
          },
        ],
        phone: [{ required: true, message: "请输入联系人", trigger: "blur" }],
        content: [
          { required: true, message: "请填写合作需求说明", trigger: "blur" },
        ],
      },
    };
  },
  created() { },
  methods: {
    submit() {
      this.$refs.cooperationForm.validate(async (valid) => {
        // 请求api之前，前端先进行的一个校验
        if (!valid) {
          return;
        }
        const result = await this.$http({
          url: "/achievementTransform/sendNeed",
          method: "POST",
          data: {
              userId: window.localStorage.getItem("user_id"),
              companyName: this.cooperation.companyName,
              name: this.cooperation.title,
              alumniName: this.cooperation.name,
              phone: this.cooperation.phone,
              description: this.cooperation.content,
          
          },
        });
        if (result.data.sendNeed == true) {
          this.$toast("提交成功");
          window.history.back(-1);
        } else {
          this.$toast(result.data.msg);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.addCooperation {
  position: relative;

  .table {
    position: relative;
    left: 5%;
    width: 90%;

    .el-form-item {
      margin-top: 15px;
    }
  }

  .submit {
    position: relative;
    left: 5%;
    margin: 30px 0 20px 0;
    width: 90%;

    .submitBtn {
      border: 0;
      border-radius: 30px;
      background: linear-gradient(270deg, #00706E, #00706E);
      color: white;
      width: 100%;
      padding: 10px 0;
      font-size: 1.2rem;
      font-weight: bold;
    }
  }
}

.title {
  margin-top: 10px;

  .icon {
    float: left;
    height: 5vw;
    width: 3px;
    background: #00706E;
    border-radius: 3px;
  }

  .titleName {
    float: left;
    margin-left: 5px;
    font-size: 1.1rem;
    font-weight: bold;
    color: #333333;
  }
}

.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.clearfix {
  *zoom: 1;
}
</style>


// WEBPACK FOOTER //
// src/components/achievements/AddCooperation.vue